module.exports = __webpack_public_path__ + "static/media/dual-ring-spinner-0.5s-200px.438ede40.svg";